var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardOs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.75 1.83333H8.25C7.74374 1.83333 7.33333 2.24374 7.33333 2.75V4.58333C7.33333 5.08959 7.74374 5.5 8.25 5.5H13.75C14.2563 5.5 14.6667 5.08959 14.6667 4.58333V2.75C14.6667 2.24374 14.2563 1.83333 13.75 1.83333Z",
    stroke: "#E60D1E",
    strokeWidth: 1.60417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.6667 3.66667H16.5C16.9862 3.66667 17.4525 3.85982 17.7964 4.20364C18.1402 4.54745 18.3333 5.01377 18.3333 5.5V18.3333C18.3333 18.8196 18.1402 19.2859 17.7964 19.6297C17.4525 19.9735 16.9862 20.1667 16.5 20.1667H5.5C5.01377 20.1667 4.54745 19.9735 4.20364 19.6297C3.85982 19.2859 3.66667 18.8196 3.66667 18.3333V5.5C3.66667 5.01377 3.85982 4.54745 4.20364 4.20364C4.54745 3.85982 5.01377 3.66667 5.5 3.66667H7.33333",
    stroke: "#E60D1E",
    strokeWidth: 1.60417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.33333 10.0833H7.3425M7.33333 13.75H7.3425M11 10.0833H14.6667M11 13.75H14.6667",
    stroke: "#E60D1E",
    strokeWidth: 1.60417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardOs);
export default __webpack_public_path__ + "static/media/card-os.5e8d05a0006951400bf0a54bcca8007f.svg";
export { ForwardRef as ReactComponent };